import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Safran({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Safran" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="safranPanel">
            <Trans i18nKey="safranDetails" />

            <h2 className="text-center titles text-blue-500">{t("technologies")}</h2>

            <p className="text-center">Electron, React, NodeJS, Express, Python, OCR, Git, Docker, SCRUM, UML, SonarQube, JUnit</p>
        </Dialog>
    )
}